import { Stack, StackProps } from '@mui/material';

//
//

export const StackColumn: React.FC<StackProps> = ({ children, gap = 2, ...props }) => {
  return (
    <Stack gap={gap} spacing={0} direction="column" width="100%" {...props}>
      {children}
    </Stack>
  );
};

//

export const StackRow: React.FC<StackProps> = ({ children, gap = 2, ...props }) => {
  return (
    <Stack gap={gap} spacing={0} direction="row" alignItems="center" {...props}>
      {children}
    </Stack>
  );
};

//

export const StackRowForm = ({ children, gap = 2, direction, ...props }: StackProps) => {
  return (
    <Stack direction={direction || { xs: 'column', sm: 'row' }} spacing={0} gap={gap} {...props}>
      {children}
    </Stack>
  );
};
